const templateUrl = require('./remove-actions.html');

module.exports = angular.module('msi.products.item-controls.remove-actions', []).name;

angular.module(module.exports)
  .component('ogItemRemoveActions', {
    templateUrl: templateUrl,
    bindings: {
      item: '<ogFor',
      onlyItemInShipment: '<?ogOnlyItemInShipment'
    }
  });
